import React from 'react';
import PropTypes from 'prop-types';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export function ProcessorStep3Methods({ formData, handleInputChange }) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-purple-900 border-b-2 border-purple-200 pb-2">
        Processing Methods
      </h3>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="space-y-4">
          <h4 className="font-semibold text-gray-800">Primary Processing</h4>
          <div>
            <Label htmlFor="podBreaking">Pod Breaking Method</Label>
            <Input
              id="podBreaking"
              value={formData.podBreaking}
              onChange={(e) => handleInputChange('podBreaking', e.target.value)}
              placeholder="e.g., Manual, Machine"
            />
          </div>
          <div>
            <Label htmlFor="beanExtraction">Bean Extraction Method</Label>
            <Input
              id="beanExtraction"
              value={formData.beanExtraction}
              onChange={(e) => handleInputChange('beanExtraction', e.target.value)}
              placeholder="e.g., Manual, Mechanical"
            />
          </div>
          <div>
            <Label htmlFor="fermentation">Fermentation Method</Label>
            <Input
              id="fermentation"
              value={formData.fermentation}
              onChange={(e) => handleInputChange('fermentation', e.target.value)}
              placeholder="e.g., Box fermentation, Heap fermentation"
            />
          </div>
          <div>
            <Label htmlFor="containmentMaterials">Containment Materials</Label>
            <Input
              id="containmentMaterials"
              value={formData.containmentMaterials}
              onChange={(e) => handleInputChange('containmentMaterials', e.target.value)}
              placeholder="e.g., Wood boxes, Banana leaves"
            />
          </div>
          <div>
            <Label htmlFor="numberOfDays">Fermentation Days</Label>
            <Input
              id="numberOfDays"
              type="number"
              value={formData.numberOfDays}
              onChange={(e) => handleInputChange('numberOfDays', e.target.value)}
              placeholder="e.g., 5"
              min="0"
            />
          </div>
          <div>
            <Label htmlFor="temperatureMonitoring">Temperature Monitoring</Label>
            <Select value={formData.temperatureMonitoring} onValueChange={(value) => handleInputChange('temperatureMonitoring', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select temperature monitoring" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
                <SelectItem value="Sometimes">Sometimes</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {formData.temperatureMonitoring === 'Yes' && (
            <div>
              <Label htmlFor="preferredFermentationTemperature">Preferred Temperature (°C)</Label>
              <Input
                id="preferredFermentationTemperature"
                type="number"
                value={formData.preferredFermentationTemperature}
                onChange={(e) => handleInputChange('preferredFermentationTemperature', e.target.value)}
                placeholder="e.g., 45"
                step="0.1"
              />
            </div>
          )}
        </div>
        
        <div className="space-y-4">
          <h4 className="font-semibold text-gray-800">Drying & Storage</h4>
          <div>
            <Label htmlFor="dryingReDrying">Drying Method</Label>
            <Input
              id="dryingReDrying"
              value={formData.dryingReDrying}
              onChange={(e) => handleInputChange('dryingReDrying', e.target.value)}
              placeholder="e.g., Solar drying, Mechanical"
            />
          </div>
          <div>
            <Label htmlFor="preferredMoistureContent">Preferred Moisture Content (%)</Label>
            <Input
              id="preferredMoistureContent"
              type="number"
              value={formData.preferredMoistureContent}
              onChange={(e) => handleInputChange('preferredMoistureContent', e.target.value)}
              placeholder="e.g., 7.5"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="beanSorting">Bean Sorting Method</Label>
            <Input
              id="beanSorting"
              value={formData.beanSorting}
              onChange={(e) => handleInputChange('beanSorting', e.target.value)}
              placeholder="e.g., Manual, Machine"
            />
          </div>
          <div>
            <Label htmlFor="beanGrading">Bean Grading System</Label>
            <Input
              id="beanGrading"
              value={formData.beanGrading}
              onChange={(e) => handleInputChange('beanGrading', e.target.value)}
              placeholder="e.g., Size and quality based"
            />
          </div>
          <div>
            <Label htmlFor="materialsUsedForDriedBeanStorage">Storage Materials</Label>
            <Input
              id="materialsUsedForDriedBeanStorage"
              value={formData.materialsUsedForDriedBeanStorage}
              onChange={(e) => handleInputChange('materialsUsedForDriedBeanStorage', e.target.value)}
              placeholder="e.g., Jute sacks, GrainPro bags"
            />
          </div>
          <div>
            <Label htmlFor="typeDrying">Type of Drying</Label>
            <Input
              id="typeDrying"
              value={formData.typeDrying}
              onChange={(e) => handleInputChange('typeDrying', e.target.value)}
              placeholder="e.g., Solar, Mechanical"
            />
          </div>
          <div>
            <Label htmlFor="methodOfMCDetermination">Moisture Content Determination Method</Label>
            <Input
              id="methodOfMCDetermination"
              value={formData.methodOfMCDetermination}
              onChange={(e) => handleInputChange('methodOfMCDetermination', e.target.value)}
              placeholder="e.g., Moisture meter, Visual assessment"
            />
          </div>
          <div>
            <Label htmlFor="usualBeanSize">Usual Bean Size</Label>
            <Input
              id="usualBeanSize"
              value={formData.usualBeanSize}
              onChange={(e) => handleInputChange('usualBeanSize', e.target.value)}
              placeholder="e.g., Large, Medium, Small"
            />
          </div>
          <div>
            <Label htmlFor="levelOfFermentation">Level of Fermentation (%)</Label>
            <Input
              id="levelOfFermentation"
              type="number"
              value={formData.levelOfFermentation}
              onChange={(e) => handleInputChange('levelOfFermentation', e.target.value)}
              placeholder="e.g., 80"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="rawBeanAroma">Raw Bean Aroma</Label>
            <Input
              id="rawBeanAroma"
              value={formData.rawBeanAroma}
              onChange={(e) => handleInputChange('rawBeanAroma', e.target.value)}
              placeholder="e.g., Fruity, Nutty, Earthy"
            />
          </div>
          <div>
            <Label htmlFor="estimatedCostOfMaterials">Estimated Cost of Materials (₱)</Label>
            <Input
              id="estimatedCostOfMaterials"
              type="number"
              value={formData.estimatedCostOfMaterials}
              onChange={(e) => handleInputChange('estimatedCostOfMaterials', e.target.value)}
              placeholder="e.g., 50000"
              step="0.01"
            />
          </div>
        </div>
        
        <div className="space-y-4">
          <h4 className="font-semibold text-gray-800">Advanced Processing</h4>
          <div>
            <Label htmlFor="roasting">Roasting</Label>
            <Select value={formData.roasting} onValueChange={(value) => handleInputChange('roasting', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use roasting?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="roastingTemperatureMonitoring">Roasting Temperature Monitoring</Label>
            <Select value={formData.roastingTemperatureMonitoring} onValueChange={(value) => handleInputChange('roastingTemperatureMonitoring', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Select roasting temperature monitoring" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
                <SelectItem value="Sometimes">Sometimes</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label htmlFor="grinding">Grinding</Label>
            <Select value={formData.grinding} onValueChange={(value) => handleInputChange('grinding', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use grinding?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.grinding === 'Yes' && (
            <div>
              <Label htmlFor="grindingType">Grinding Method</Label>
              <Input
                id="grindingType"
                value={formData.grindingType}
                onChange={(e) => handleInputChange('grindingType', e.target.value)}
                placeholder="e.g., Stone grinding, Machine"
              />
            </div>
          )}
          <div>
            <Label htmlFor="conching">Conching</Label>
            <Select value={formData.conching} onValueChange={(value) => handleInputChange('conching', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use conching?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.roasting === 'Yes' && (
            <div>
              <Label htmlFor="roastingMethod">Roasting Method Type</Label>
              <Input
                id="roastingMethod"
                value={formData.roastingMethod}
                onChange={(e) => handleInputChange('roastingMethod', e.target.value)}
                placeholder="e.g., Light roast, Dark roast"
              />
            </div>
          )}
          <div>
            <Label htmlFor="averageTimeSpent">Average Time Spent (hours)</Label>
            <Input
              id="averageTimeSpent"
              value={formData.averageTimeSpent}
              onChange={(e) => handleInputChange('averageTimeSpent', e.target.value)}
              placeholder="e.g., 2 hours"
            />
          </div>
          <div>
            <Label htmlFor="preferredRoastingTemperature">Preferred Roasting Temperature (°C)</Label>
            <Input
              id="preferredRoastingTemperature"
              type="number"
              value={formData.preferredRoastingTemperature}
              onChange={(e) => handleInputChange('preferredRoastingTemperature', e.target.value)}
              placeholder="e.g., 150"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="cracking">Cracking</Label>
            <Select value={formData.cracking} onValueChange={(value) => handleInputChange('cracking', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use cracking?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.cracking === 'Yes' && (
            <div>
              <Label htmlFor="crackingType">Cracking Method</Label>
              <Input
                id="crackingType"
                value={formData.crackingType}
                onChange={(e) => handleInputChange('crackingType', e.target.value)}
                placeholder="e.g., Manual, Machine"
              />
            </div>
          )}
          <div>
            <Label htmlFor="winnowing">Winnowing</Label>
            <Select value={formData.winnowing} onValueChange={(value) => handleInputChange('winnowing', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use winnowing?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.winnowing === 'Yes' && (
            <div>
              <Label htmlFor="winnowingType">Winnowing Method</Label>
              <Input
                id="winnowingType"
                value={formData.winnowingType}
                onChange={(e) => handleInputChange('winnowingType', e.target.value)}
                placeholder="e.g., Manual, Fan winnowing"
              />
            </div>
          )}

          <div>
            <Label htmlFor="preferredMicronsSize">Preferred Microns Size</Label>
            <Input
              id="preferredMicronsSize"
              type="number"
              value={formData.preferredMicronsSize}
              onChange={(e) => handleInputChange('preferredMicronsSize', e.target.value)}
              placeholder="e.g., 18"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="tempering">Tempering</Label>
            <Select value={formData.tempering} onValueChange={(value) => handleInputChange('tempering', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use tempering?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.tempering === 'Yes' && (
            <div>
              <Label htmlFor="temperingType">Tempering Method</Label>
              <Input
                id="temperingType"
                value={formData.temperingType}
                onChange={(e) => handleInputChange('temperingType', e.target.value)}
                placeholder="e.g., Manual, Machine tempering"
              />
            </div>
          )}

          {formData.tempering === 'Yes' && (
            <div>
              <Label htmlFor="preferredTemperingTemperature">Preferred Tempering Temperature (°C)</Label>
              <Input
                id="preferredTemperingTemperature"
                type="number"
                value={formData.preferredTemperingTemperature}
                onChange={(e) => handleInputChange('preferredTemperingTemperature', e.target.value)}
                placeholder="e.g., 27"
              />
            </div>
          )}

          <div>
            <Label htmlFor="moulding">Moulding</Label>
            <Select value={formData.moulding} onValueChange={(value) => handleInputChange('moulding', value)}>
              <SelectTrigger>
                <SelectValue placeholder="Do you use moulding?" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Yes">Yes</SelectItem>
                <SelectItem value="No">No</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {formData.moulding === 'Yes' && (
            <div>
              <Label htmlFor="mouldingType">Moulding Method</Label>
              <Input
                id="mouldingType"
                value={formData.mouldingType}
                onChange={(e) => handleInputChange('mouldingType', e.target.value)}
                placeholder="e.g., Hand molding, Machine molding"
              />
            </div>
          )}
          <div>
            <Label htmlFor="storageOfProcessedProduct">Storage of Processed Product</Label>
            <Input
              id="storageOfProcessedProduct"
              value={formData.storageOfProcessedProduct}
              onChange={(e) => handleInputChange('storageOfProcessedProduct', e.target.value)}
              placeholder="e.g., Cool dry place, Refrigerated"
            />
          </div>
          <div>
            <Label htmlFor="preferredStorageTemperature">Preferred Storage Temperature (°C)</Label>
            <Input
              id="preferredStorageTemperature"
              type="number"
              value={formData.preferredStorageTemperature}
              onChange={(e) => handleInputChange('preferredStorageTemperature', e.target.value)}
              placeholder="e.g., 18"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="preferredRelativeHumidity">Preferred Relative Humidity (%)</Label>
            <Input
              id="preferredRelativeHumidity"
              type="number"
              value={formData.preferredRelativeHumidity}
              onChange={(e) => handleInputChange('preferredRelativeHumidity', e.target.value)}
              placeholder="e.g., 65"
              step="0.1"
            />
          </div>
          <div>
            <Label htmlFor="packagingMaterial">Packaging Material</Label>
            <Input
              id="packagingMaterial"
              value={formData.packagingMaterial}
              onChange={(e) => handleInputChange('packagingMaterial', e.target.value)}
              placeholder="e.g., Plastic bags, Paper bags"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

ProcessorStep3Methods.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};
